// extracted by mini-css-extract-plugin
export default {"name":"style_name__CcfU4"};